export enum BreadcrumbType {
  Static, //Route stays the same always
  Dynamic, //Route changes for example an id
}
